import { Navigate,Outlet } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";

export const AccountRoute = ({ children }) => {
  const { user,tokenDetails } = useAuth();
  if (user && tokenDetails) {
    return <Navigate to="/admin/dashboard" />;
  }

  return(<><Outlet></Outlet></>);
};

